import React from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutline";
import { Box, Button, Grid2, TextField, Typography, TextareaAutosize } from "@mui/material";
import Address from "components/common/Address";
import MuiPhoneNumber from "material-ui-phone-number";
import PropTypes from "prop-types";
import { getFullAddress } from "../../utils";
import { infoSection } from "./styles";
import { formatPhones } from "../../../../core/formats";

const ContactListItem = (props) => {
    const classes = infoSection();

    const {
        disabled,
        values,
        handleRemove,
        index,
        commonProps,
        errors,
        isLastItem,
        listLength,
        touched,
        addAddress,
        onChangePhone,
    } = props;

    if (disabled) {
        const leftProps = {
            xs: 12,
            sm: 4,
            md: 4,
            lg: 3,
            xl: 1,
        };
        const rightProps = {
            xs: 12,
            sm: 8,
            md: 8,
            lg: 9,
            xl: 11,
            wrap: "nowrap",
        };

        const showValues = (values.phone1 || values.phone2 || values.fax || values.email || getFullAddress(values)) ? true : false;
        return (
            showValues ? <Grid2 container spacing={1} size={12}>
                {(values.phone1 || values.phone2 || values.fax) &&
                    <Grid2 size={{ ...leftProps }}>
                        <Typography>Phone:</Typography>
                    </Grid2>}
                {(values.phone1 || values.phone2 || values.fax) &&
                    <Grid2 size={{ ...rightProps }}>
                        <Typography>
                            {formatPhones([
                                { number: values.phone1, type: "Home" },
                                { number: values.phone2, type: "Mobile" },
                                { number: values.fax, type: "Fax" },
                            ])}
                        </Typography>
                    </Grid2>}
                {values.email &&
                    <Grid2 size={{ ...leftProps }}>
                        <Typography>Email:</Typography>
                    </Grid2>}
                {values.email &&
                    <Grid2 size={{ ...rightProps }}>
                        <Typography>{values.email}</Typography>
                    </Grid2>}
                {getFullAddress(values) &&
                    <Grid2 size={{ ...leftProps }}>
                        <Typography>Address:</Typography>
                    </Grid2>}
                {getFullAddress(values) &&
                    <Grid2 size={{ ...rightProps }}>
                        <Typography>{getFullAddress(values)}</Typography>
                    </Grid2>}
            </Grid2> : null
        );
    }
    const haveDelete = listLength > 0;
    return (
        (<Box style={{ marginBottom: 10 }}>
            <Grid2 container spacing={3}>
                <Grid2

                    size={{
                        xs: 12,
                        md: 12
                    }}>
                    <Box>
                        <Grid2 container spacing={2}>
                            <Grid2
                                size={{
                                    xs: 6,
                                    sm: 6,
                                    md: 4,
                                    lg: 4
                                }}>
                                <Grid2 size={12}>
                                    <Typography>Office or Home</Typography>
                                </Grid2>
                                <MuiPhoneNumber
                                    disableDropdown
                                    disableAreaCodes
                                    disableCountryCode
                                    variant="outlined"
                                    defaultCountry={"us"}
                                    onlyCountries={["us"]}
                                    fullWidth
                                    disabled={disabled}
                                    onChange={(phone) => onChangePhone(phone, "addressList[" + index + "].phone1")}
                                    value={values.phone1}
                                    error={errors && touched && touched.phone1 ? errors.phone1 : null}
                                    helperText={errors && touched && touched.phone1 ? errors.phone1 : null}
                                    autoFormat={"on"}
                                    placeholder="Office or Home"
                                    onBlur={commonProps("addressList[" + index + "].phone1").onBlur}
                                    name={"addressList[" + index + "].phone1"}
                                />
                            </Grid2>
                            <Grid2
                                size={{
                                    xs: 6,
                                    sm: 6,
                                    md: 4,
                                    lg: 4
                                }}>
                                <Grid2 size={12}>
                                    <Typography>Mobile</Typography>
                                </Grid2>
                                <MuiPhoneNumber
                                    disableDropdown
                                    disableAreaCodes
                                    disableCountryCode
                                    variant="outlined"
                                    defaultCountry={"us"}
                                    onlyCountries={["us"]}
                                    fullWidth
                                    disabled={disabled}
                                    onChange={(phone) => onChangePhone(phone, "addressList[" + index + "].phone2")}
                                    value={values.phone2}
                                    error={errors && touched && touched.phone2 ? errors.phone2 : null}
                                    helperText={errors && touched && touched.phone2 ? errors.phone2 : null}
                                    autoFormat={"on"}
                                    placeholder="Mobile"
                                    onBlur={commonProps("addressList[" + index + "].phone2").onBlur}
                                    name={"addressList[" + index + "].phone2"}
                                />
                            </Grid2>
                            <Grid2
                                size={{
                                    xs: 6,
                                    sm: 6,
                                    md: 4,
                                    lg: 4
                                }}>
                                <Grid2 size={12}>
                                    <Typography>Fax</Typography>
                                </Grid2>
                                <MuiPhoneNumber
                                    disableDropdown
                                    disableAreaCodes
                                    disableCountryCode
                                    variant="outlined"
                                    defaultCountry={"us"}
                                    onlyCountries={["us"]}
                                    fullWidth
                                    disabled={disabled}
                                    onChange={(phone) => onChangePhone(phone, "addressList[" + index + "].fax")}
                                    value={values.fax}
                                    error={errors && touched && touched.fax ? errors.fax : null}
                                    helperText={errors && touched && touched.fax ? errors.fax : null}
                                    autoFormat={"on"}
                                    placeholder="Fax"
                                    onBlur={commonProps("addressList[" + index + "].fax").onBlur}
                                    name={"addressList[" + index + "].fax"}
                                />
                            </Grid2>
                        </Grid2>
                    </Box>
                </Grid2>
                <Grid2 style={{ marginBottom: 50 }} spacing={1} container size={12}>
                    <Grid2 size={12}>
                        <Typography>Email</Typography>
                    </Grid2>
                    <Grid2 size={12}>
                        <TextField
                            {...commonProps("addressList[" + index + "].email")}
                            value={values.email}
                            style={{ minWidth: "100%", maxWidth: "100%", paddingLeft: 0 }}
                            error={errors && touched && touched.email ? errors.email : null}
                            helperText={errors && touched && touched.email ? errors.email : null}
                            disabled={disabled}
                            className={"inputTextArea"}
                            placeholder="example@mail.com"
                            multiline
                            slotProps={{
                                input: {
                                    inputComponent: TextareaAutosize,
                                    inputProps: {
                                        style: {
                                            height: 40,
                                            overflow: "auto",
                                            margin: "-10px 0px",
                                        },
                                    },
                                }
                            }}
                        />
                    </Grid2>
                </Grid2>
                <Grid2 size={12}>
                    <Box>
                        <Address
                            inside_spacing={2}
                            values={values}
                            index={index}
                            commonProps={commonProps}
                            disabled={disabled}
                        />
                    </Box>
                </Grid2>
                {!disabled && (
                    <Grid2 size={12}>
                        {haveDelete && (
                            <Button
                                variant="outlined"
                                style={{ float: "right", marginLeft: 5 }}
                                size={"small"}
                                onClick={handleRemove}
                            >
                                <DeleteIcon className={classes.deleteIcon} />
                                Delete
                            </Button>
                        )}
                        {isLastItem && (
                            <Button variant="outlined" style={{ float: "right" }} size={"small"} onClick={addAddress}>
                                <AddIcon />
                                Add Contact Info
                            </Button>
                        )}
                    </Grid2>
                )}
            </Grid2>
        </Box>)
    );
};

ContactListItem.propTypes = {
    values: PropTypes.object.isRequired,
    disabled: PropTypes.bool.isRequired,
    handleRemove: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    commonProps: PropTypes.func.isRequired,
    errors: PropTypes.object,
    isLastItem: PropTypes.bool.isRequired,
    listLength: PropTypes.number.isRequired,
    touched: PropTypes.object,
    addAddress: PropTypes.func.isRequired,
    onChangePhone: PropTypes.func.isRequired,
};

export default ContactListItem;
